import {createModel} from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import {
    ProSkillAssureAssessmentSetModel
} from "~~/package/mapper/proSkillAssure/model/assessment/ProSkillAssureAssessmentSetModel";

export class ProSkillAssureAssessmentModel extends Model {
    constructor(
        public title: string = "",
        public time: number = 0,
        public isNoTimeLimit: boolean = false,
        public setList: ProSkillAssureAssessmentSetModel[] = [],
    ) {
        super();
    }

    public static create(model: Partial<ProSkillAssureAssessmentModel>): ProSkillAssureAssessmentModel {
        return createModel<ProSkillAssureAssessmentModel>(ProSkillAssureAssessmentModel, {
            ...model
        });
    }
}
